import { createSchemaFormatter } from '@shopee-user-common/schema-formatter';
import { config } from '@shopee-user/platform';
import { Env } from '@shopee-user/global';

const {
  // Primitives
  _string,
  _number,
  _boolean,
  _null,
  _undefined,
  _literal,
  // Complex
  _object,
  _array,
  _intersect,
  _union,
  // Convenience
  _enum,
  _optionalNullable,
  _optional,
  _nullable,
  formatResponseDataField,
} = createSchemaFormatter({
  logOnFail: config.ENV !== Env.Live,
  onFailure: () => {
    // Log to sentry in live
    // TBD
  },
});

export {
  // Primitives
  _string,
  _number,
  _boolean,
  _null,
  _undefined,
  _literal,
  // Complex
  _object,
  _array,
  _intersect,
  _union,
  // Convenience
  _enum,
  _optionalNullable,
  _optional,
  _nullable,
  formatResponseDataField,
};

export type { TypeOf } from '@shopee-user-common/schema-formatter';
